import {
  Context,
  CustomQuery,
  useProductFactory,
  UseProductFactoryParams
} from '@vue-storefront/core';
import type { Product } from '@bee-hole/api';
import type { UseProductSearchParams as SearchParams } from '../types';
import { useFacet } from '../useFacet';
import { useApiError } from '../useApiError';
const params: UseProductFactoryParams<Product, SearchParams> = {
  provide: () => ({
    useFacet: useFacet(),
    useApiError: useApiError()
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  productsSearch: async (context: Context, parms: CustomQuery) => {
    const { goodId } = parms;
    if (goodId) {
      const res = await context.$xbuy.api.goodInfo(goodId);
      if (res && res.code && res.code > 0) {
        context.useApiError.set(res);
        throw new Error(res.message);
      }
      return { list: [res.data] };
    } else {
      await context.useFacet.search(parms);
      return context.useFacet.result.value.data;
    }
  }
};

export const useProduct = useProductFactory<Product, SearchParams>(params);
